import Parallax from 'parallax-js'
// Определяем селектор для паралакса
let scene = document.querySelector('.footer__scene');
let parallaxInstance = new Parallax(scene, {
    hoverOnly: true,
    frictionY: 0
});
(function () {
    'use strict';

    function trackScroll() {
        var scrolled = window.pageYOffset;
        var coords = document.documentElement.clientHeight;

        if (scrolled > coords) {
            goTopBtn.classList.add('footer__top_button--show');
        }
        if (scrolled < coords) {
            goTopBtn.classList.remove('footer__top_button--show');
        }
    }

    function backToTop() {
        if (window.pageYOffset > 0) {
            window.scrollBy(0, -50);
            setTimeout(backToTop, 0);
        }
    }

    var goTopBtn = document.querySelector('.footer__top_button');

    window.addEventListener('scroll', trackScroll);
    goTopBtn.addEventListener('click', backToTop);
})();